// Buddy Brand Fitness - Custom JavaScript
// Klarna On-Site Messaging replaces Affirm (MID: N2440285)
// Klarna script is auto-injected via Shopify ScriptTag — no manual loader needed.

// ─────────────────────────────────────────────────────────────
// PASSIVE CART CLEAR
// Silently empties the cart whenever a visitor lands on ANY page
// of this store (product pages, homepage, etc.).
// This prevents stale line-items from a previous session showing
// up in Shopify's checkout if the customer navigates back or
// shares a link between sessions.
// It runs in the background — the user never sees a cart page.
// ─────────────────────────────────────────────────────────────
function clearCartSilently() {
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  }).catch(function() {
    // Silently ignore — non-critical background operation
  });
}

// Clear on initial page load
clearCartSilently();

// Clear again on back-button / bfcache restore
// (pageshow fires even when the page is restored from browser cache)
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    clearCartSilently();
  }
});

// ─────────────────────────────────────────────────────────────
// MAIN DOM-READY LOGIC
// ─────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function() {

  // Initialize Klarna OSM when DOM is ready
  if (window.Klarna && window.Klarna.OnsiteMessaging) {
    window.Klarna.OnsiteMessaging.refresh();
  }

  // ── FORM SUBMIT HANDLER ──────────────────────────────────
  // Intercepts all product form submissions, clears cart,
  // adds the chosen variant, then redirects straight to /checkout.
  const productForms = document.querySelectorAll('form[action*="/cart"]');
  productForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const variantIdInput = form.querySelector('input[name="id"]');
      if (!variantIdInput) return;

      const variantId = variantIdInput.value;

      // Show a brief loading state on the button so the user
      // knows something is happening
      const btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Processing…';
      }

      // Step 1: clear → Step 2: add → Step 3: go to checkout
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(function() {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
      })
      .then(function(response) { return response.json(); })
      .then(function() {
        window.location.href = '/checkout';
      })
      .catch(function(error) {
        console.error('Checkout error:', error);
        // Restore button so customer can retry
        if (btn) {
          btn.disabled = false;
          btn.textContent = '🚀 Enroll Now - Get Instant Platform Access';
        }
        // Fallback direct-cart URL
        window.location.href = '/cart/' + variantId + ':1?checkout';
      });
    });
  });

  // ── MONTHLY PAYMENT DISPLAY ──────────────────────────────
  // Updates any hidden #monthly-payment span (used by Klarna OSM
  // refresh only — not shown to users as static text).
  const monthlyPaymentElements = document.querySelectorAll('[id*="monthly-payment"]');
  monthlyPaymentElements.forEach(function(element) {
    const priceElement = element.closest('.product-card') &&
                         element.closest('.product-card').querySelector('.current-price');
    if (priceElement) {
      const priceText = priceElement.textContent.replace(/[^0-9.]/g, '');
      const price = parseFloat(priceText);
      if (price && !isNaN(price)) {
        const months = price >= 5000 ? 36 : 24;
        element.textContent = Math.ceil(price / months);
      }
    }
  });

  // ── HIDE CART NAVIGATION (FAILSAFE) ─────────────────────
  // Belt-and-suspenders: in case any Shopify-injected app or
  // section renders a cart icon/link, hide it after render.
  setTimeout(function() {
    var cartSelectors = [
      '.cart-icon',
      '.cart-link',
      'a[href="/cart"]',
      'a[href^="/cart?"]',
      '.cart-count-bubble',
      '.header__icons .cart',
      'header .cart',
      '.site-header .cart',
      '.shopify-section-header .cart'
    ];

    cartSelectors.forEach(function(selector) {
      var elements = document.querySelectorAll(selector);
      elements.forEach(function(el) {
        if (!el.classList.contains('enroll-button') &&
            !el.id.includes('add-to-cart-button')) {
          el.style.cssText += ';display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;';
        }
      });
    });
  }, 100);

});

// ─────────────────────────────────────────────────────────────
// KLARNA OSM REFRESH HELPER
// Call this whenever the displayed price changes dynamically.
// ─────────────────────────────────────────────────────────────
function refreshKlarnaOSM() {
  if (window.Klarna && window.Klarna.OnsiteMessaging) {
    window.Klarna.OnsiteMessaging.refresh();
  }
}
